import { ListBranch, Visibility } from 'app/area/link-codes/types-store';

export const getCurrentBranchItems = (
  id: number, listBranch: ListBranch[], checkedValues: { [id: number]: boolean },
  visiblity: Visibility) => {

  const shouldDislayItem = (checked: boolean, visibility: Visibility) =>
    visibility === Visibility.all ||
    (checked && visibility === Visibility.selected) ||
    (!checked && visibility === Visibility.unselected);
  const currentBranch = listBranch.find(branch => branch.id === id);

  return (currentBranch?.items ?? [])
    .filter(item => shouldDislayItem(checkedValues[item.id], visiblity));
};
